/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidSubmissionsControllerCreateMutationRequest, BidSubmissionsControllerCreateMutationResponse, BidSubmissionsControllerCreate400, BidSubmissionsControllerCreate401, BidSubmissionsControllerCreate403 } from "../../models/bidsController/BidSubmissionsControllerCreate";

function getBidSubmissionsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/bid-submissions` as const }  
  return res
}

/**
 * @description Creates one submission in IDENTIFYING; CrunchAI then works out who sent it and whether it is a bid or a reply. 409 when the same file is already in the trade.
 * @summary Drop uploaded files into a trade
 * {@link /api/v1/bid-submissions}
 */
export async function bidSubmissionsControllerCreate(data?: BidSubmissionsControllerCreateMutationRequest, config: Partial<RequestConfig<BidSubmissionsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidSubmissionsControllerCreateMutationResponse, ResponseErrorConfig<BidSubmissionsControllerCreate400 | BidSubmissionsControllerCreate401 | BidSubmissionsControllerCreate403>, BidSubmissionsControllerCreateMutationRequest>({ method : "POST", url : getBidSubmissionsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}